module.exports = __webpack_public_path__ + "static/media/logo.f9a0a46a.png";